import { Inject, injectable } from "inversify-props";
import { MotivosDeCancelamentoServiceAdapter } from "./adapter/MotivosDeCancelamentoServiceAdapter";
import { MotivoCancelamento } from "@/models/MotivoCancelamento";

@injectable()
export class SaveMotivosDeCancelamentoUseCase {
	@Inject("MotivosDeCancelamentoServiceAdapter")
	private motivosDeCancelamentoAdapter!: MotivosDeCancelamentoServiceAdapter;

	create = async (motivo: MotivoCancelamento) => 
		await this.motivosDeCancelamentoAdapter.create(motivo);

	update = async (motivo: MotivoCancelamento) => 
		await this.motivosDeCancelamentoAdapter.update(motivo)
}